// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9304) return "static/chunks/9304-e600d2a1c7d2e2a6.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7336 ? "db885604" : chunkId) + "." + {"5243":"cb7bf89a6bef88cb","7336":"cf0a73f8f9e5163c"}[chunkId] + ".js";
};